<main>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    PAGAMENTOS
                </div>
                <p>Veja aqui todos os seus pagamentos </p>
            </div>
        </div>
        <div class="separador-2"></div>
        <div class="row">
            <div class="col-md-12 text-right" *ngIf="true">
                <ul class="options-cadastro">
                    <li>
                        <div (click)="showFilter(filtro)" class="list-select ml-2
                            my-1">
                            <button _ngcontent-khv-c20="" class="list-select" type="button">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input ml-2 my-1">
                            <input class="w-100 ng-untouched ng-pristine
                                ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChanged(1)" />
                        </div>
                    </li>
                    <li>
                        <div class="list-select ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                <option _ selected="" value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>

            <!--<div class="col-md-12" *ngIf="isMobile">
                <div class="list-select-search-input list-select-search-input-mobile ml-2 my-1">
                    <input class="w-100 ng-untouched ng-pristine ng-valid" placeholder="Pesquise aqui..." type="search"
                        [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChanged(1)" />
                </div>
                <button class="btn-search" (click)="pageChanged(1)">
                    Buscar
                </button>
            </div>-->
        </div>

        <div class="row mt-5">
            <div class="col-12">
                <ng-container *ngFor="
                        let item of intencoesDeposito
                            | paginate
                                : {
                                      itemsPerPage: showItem,
                                      currentPage: currentPage,
                                      totalItems: totalItems
                                  }
                    ">
                    <!--<div *ngIf="isMobile">
                        <div ngbDropdown class="d-inline-block menu-option button-mobile" placement="left">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                <img src="assets/icons/menu.png" />
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div ngbDropdownItem (click)="edit(item)">
                                        <img src="assets/icons/pencil-purple.png" class="mr-2" />Editar Favorecido
                                    </div>

                                    <div *ngIf="permitirVincularQRCode" ngbDropdownItem (click)="
                                            ShowModalQRCode(modalQRCode, item)
                                        ">
                                        <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Vincular
                                        QR Code
                                    </div>

                                    <div ngbDropdownItem *ngIf="false" (click)="
                                            NavigateToGestaoBeneficios(item)
                                        ">
                                        <img src="assets/icons/user-purple.png" class="mr-2" />Gestão de Incentivos
                                    </div>

                                    <div ngbDropdownItem (click)="
                                            ShowModalBenefits(
                                                benefitsModal,
                                                item
                                            )
                                        ">
                                        <img src="assets/icons/contrato.png" class="mr-2" />Ver Detalhes
                                    </div>

                                    <div ngbDropdownItem (click)="
                                            ShowModalAlterarSenha(
                                                modalAlterarSenha,
                                                item
                                            )
                                        ">
                                        <img src="assets/icons/user-purple.png" class="mr-2" style="width:15px" />
                                        Alterar Senha
                                    </div>

                                    <div ngbDropdownItem *ngIf="false" (click)="showDelete(deletemodal, item)">
                                        <img src="assets/icons/garbage-purple.png" class="mr-2" />Desligar Favorecido:
                                        {{ item.nome }}
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>-->

                    <!--<table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" *ngIf="isMobile">
                        <tbody class="list-table-row">
                            <tr *ngIf="
                                    permitirVincularQRCode &&
                                    item.statusApp === 'Pendente'
                                ">
                                <td style="border: transparent;">
                                    <div (click)="
                                            ShowModalQRCode(modalQRCode, item)
                                        " class="text-center">
                                        <img src="assets/icons/barcode.png" />
                                        <p>Vincular QR Code</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="td-mobile">Nome:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.nome }} {{ item.sobrenome }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">CPF:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.documento | cpf }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">{{ labelMatricula }}:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    {{ item.matricula }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">Unidade:</td>
                                <td class="clickable" (click)="
                                        item.toDelete = !item.toDelete;
                                        updateDeleteCount()
                                    ">
                                    <span *ngIf="item.nomeUnidade">{{
                                        item.nomeUnidade
                                    }}</span>
                                    <span *ngIf="!item.nomeUnidade">Nenhum</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>-->
                </ng-container>

                <div class="table-responsive">
                    <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                        <thead>
                            <tr>
                                <!-- <th></th> -->
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('intencaoDepositoId', sortOrder)
                                    ">
                                    Código
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('identificador', sortOrder)
                                    ">
                                    Identificador
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('valor', sortOrder)
                                    ">
                                    Valor
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('dataCadastro', sortOrder)
                                    ">
                                    Data de Cadastro
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('dataProcessamento', sortOrder)
                                    ">
                                    Data de Processamento
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('dataCancelamento', sortOrder)
                                    ">
                                    Data de Cancelamento
                                </th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor="
                                    let item of intencoesDeposito
                                        | paginate
                                            : {
                                                  itemsPerPage: showItem,
                                                  currentPage: currentPage,
                                                  totalItems: totalItems
                                              }
                                ">
                                <td class="clickable">
                                    {{ item.intencaoDepositoId }}
                                </td>
                                <td class="clickable">
                                    <span *ngIf="item.identificador">{{
                                        item.identificador
                                    }}</span>
                                    <span *ngIf="!item.identificador">Sem identificador</span
                                    >
                                </td>
                                <td>
                                    {{ item.valor | currency: "BRL":true }}
                                </td>
                                <td class="clickable">
                                    {{ item.dataCadastro | date: "dd/MM/yyyy" }}
                                </td>
                                <td class="clickable">
                                    <span *ngIf="item.dataProcessamento">{{
                                        item.dataProcessamento
                                            | date: "dd/MM/yyyy"
                                    }}</span>
                                    <span *ngIf="!item.dataProcessamento && !item.dataCancelamento">Aguardando processamento</span
                                    >
                                    <span *ngIf="item.dataCancelamento">Cancelado</span
                                    >
                                </td>
                                <td class="clickable">
                                    <span *ngIf="item.dataCancelamento">{{
                                        item.dataCancelamento
                                            | date: "dd/MM/yyyy"
                                    }}</span>
                                    <span *ngIf="!item.dataCancelamento">-</span
                                    >
                                </td>
                                <!--MENU-->
                                <td>
                                    <div
                                        ngbDropdown
                                        class="d-inline-block
                                        menu-option"
                                        placement="left"
                                    >
                                        <button
                                            class="dropdown-button"
                                            id="dropdown-menu"
                                            ngbDropdownToggle
                                        >
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div
                                            ngbDropdownMenu
                                            aria-labelledby="dropdown-menu"
                                            class="p-0 m-0"                          
                                        >
                                            <section
                                                class="custom-context-menu"
                                            >
                                                <div
                                                    ngbDropdownItem
                                                    *ngIf="
                                                        item.dataProcessamento ===
                                                            null &&
                                                        (item.tipoDepositoId ===
                                                            null ||
                                                            item.tipoDepositoId ===
                                                                2)
                                                    "
                                                    (click)="
                                                        showVisualizarIntencaoDeposito(
                                                            visualizarIntencaoDeposito,
                                                            item.intencaoDepositoId
                                                        )
                                                    "
                                                >
                                                    <img
                                                        src="assets/icons/contrato.png"
                                                    />
                                                    Visualizar intenção de
                                                    depósito
                                                </div>
                                                <div
                                                    ngbDropdownItem
                                                    *ngIf="
                                                        item.tipoDepositoId ===
                                                            1 &&
                                                        item.dataProcessamento ===
                                                            null &&
                                                        item.dataCancelamento ===
                                                            null &&
                                                        item.boletoInfo
                                                    "
                                                    (click)="
                                                        showVisualizarBoleto(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <img
                                                        src="assets/icons/contrato.png"
                                                    />
                                                    Visualizar boleto
                                                </div>
                                                <div
                                                    ngbDropdownItem
                                                    *ngIf="
                                                        item.tipoDepositoId ===
                                                            1 &&
                                                        item.dataProcessamento ===
                                                            null &&
                                                        item.dataCancelamento ===
                                                            null &&
                                                        item.boletoInfo === null
                                                    "
                                                    (click)="gerarBoleto(item)"
                                                >
                                                    <img
                                                        src="assets/icons/contrato.png"
                                                    />
                                                    Gerar boleto
                                                </div>
                                                <div
                                                    ngbDropdownItem
                                                    *ngIf="
                                                        item.tipoDepositoId ===
                                                            1 &&
                                                        item.dataProcessamento ===
                                                            null &&
                                                        item.dataCancelamento ===
                                                            null &&
                                                        item.boletoInfo &&
                                                        item.boletoInfo
                                                            .situacaoId === 3 &&
                                                        !item.boletoInfo
                                                            .segundaVia
                                                    "
                                                    (click)="gerarBoleto(item)"
                                                >
                                                    <img
                                                        src="assets/icons/contrato.png"
                                                    />
                                                    Gerar boleto 2ª via
                                                </div>
                                                <div
                                                    ngbDropdownItem
                                                    *ngIf="
                                                        item.dataProcessamento
                                                    "
                                                    (click)="
                                                        showVisualizarReciboIntencaoDeposito(
                                                            visualizarRecibo,
                                                            item.intencaoDepositoGuid
                                                        )
                                                    "
                                                >
                                                    <img
                                                        src="assets/icons/contrato.png"
                                                    />
                                                    Gerar recibo
                                                </div>
                                                <div ngbDropdownItem *ngIf="
                                                        item.tipoDepositoId ==
                                                        5
                                                    " (click)="showQRCodePagar(modalQRCodePagar, item.solicitacaoId, item.brCodePIX)">
                                                        <img src="assets/icons/comprovante.png" class="mr-2" /> Mostrar QRCode
                                                    </div>
                                                
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div
                        *ngIf="intencoesDeposito.length === 0"
                        class="text-center"
                    >
                        <h6>
                            Nenhuma intenção de depósito carregada. Faça uma
                            busca para retornar a lista de intenções de depósito
                            ou crie um pedido
                        </h6>
                    </div>

                    <div class="list-pagination ml-auto" *ngIf="!isMobile">
                        <pagination-controls
                            (pageChange)="pageChanged($event)"
                            responsive="true"
                            previousLabel=""
                            nextLabel=""
                        ></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<!--Visualizar Intenção de Depósito-->
<ng-template #visualizarIntencaoDeposito let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Intenção de depósito
            </h5>
            <p class="clean-modal-subtitle">
                Visualize abaixo os dados da intenção de depósito.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-section-title">Conta de origem</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.origemBancoNome }}
                </div>
                <div class="clean-modal-text">
                    <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.origemBanco }}
                </div>
                <div class="clean-modal-text">
                    <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.origemAgencia }}
                    <span *ngIf="intencaoDepositoDetalhes.origemDigitoAgencia">-{{ intencaoDepositoDetalhes.origemDigitoAgencia }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta:</span> {{ intencaoDepositoDetalhes.origemConta }}
                    <span *ngIf="intencaoDepositoDetalhes.origemDigitoConta">-{{ intencaoDepositoDetalhes.origemDigitoConta }}</span
            >
        </div>

        <br />

        <div class="clean-modal-section-title">Transfira para</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.destinoBancoNome }}
                </div>
                <div class="clean-modal-text">
                    <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.destinoBanco }}
                </div>
                <div class="clean-modal-text">
                    <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.destinoAgencia }}
                    <span *ngIf="intencaoDepositoDetalhes.destinoDigitoAgencia">-{{ intencaoDepositoDetalhes.destinoDigitoAgencia }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta: </span
            >{{ intencaoDepositoDetalhes.destinoConta }}
            <span *ngIf="intencaoDepositoDetalhes.destinoDigitoConta"
                >-{{ intencaoDepositoDetalhes.destinoDigitoConta }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Código de identificação:</span> {{ intencaoDepositoDetalhes.intencaoDepositoId }}
                </div>
                <div class="clean-modal-text">
                    <span class="clean-modal-span">Favorecido:</span> {{ intencaoDepositoDetalhes.destinoRazaoSocial }}
                </div>
                <div class="clean-modal-text" *ngIf="
                intencaoDepositoDetalhes.origemBanco !==
                intencaoDepositoDetalhes.destinoBanco
            ">
                    <span class="clean-modal-span">CNPJ:</span> {{ intencaoDepositoDetalhes.destinoCNPJ.toString() | cnpj }}
                </div>
            </div>

            <div class="col-12 clean-modal-footer">
                <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
            </div>
            </ng-template>

            <!-- Modal do recibo -->
            <ng-template #visualizarRecibo let-modal>
                <div class="col-12 modal-header clean-modal-header">
                    <div class="col-md-12">
                        <h5 class="modal-title clean-modal-title">
                            Recibo
                        </h5>
                        <p class="clean-modal-subtitle">
                            Visualize abaixo os dados do seu recibo.
                        </p>
                    </div>
                </div>
                <div class="col-12 clean-modal-content">
                    <div class="clean-modal-section-title">Comprovante de pagamento</div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.guidId">
                        <span class="clean-modal-span">Código da transação:</span> {{ reciboIntencaoDeposito.guidId }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.id">
                        <span class="clean-modal-span">Pagamento:</span> {{ reciboIntencaoDeposito.id }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.meioPagamento">
                        <span class="clean-modal-span">Forma de Pagamento:</span> {{ reciboIntencaoDeposito.meioPagamento }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.dataProcessamento">
                        <span class="clean-modal-span">Data de Processamento:</span> {{ reciboIntencaoDeposito.dataProcessamento | date: "dd/MM/yyyy" }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPedido">
                        <span class="clean-modal-span">Total pedido:</span> {{ reciboIntencaoDeposito.valorPedido | currency: "BRL":true }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.valorPago">
                        <span class="clean-modal-span">Total pago:</span> {{ reciboIntencaoDeposito.valorPago | currency: "BRL":true }}
                    </div>
                    <div *ngIf="reciboIntencaoDeposito.identificador" class="clean-modal-text">
                        <span class="clean-modal-span">Identificador:</span> {{ reciboIntencaoDeposito.identificador }}
                    </div>
                    <hr *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia"/>
                    <div class="clean-modal-section-title" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico || reciboIntencaoDeposito.pagadorNomeFantasia">Pagador</div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeJuridico">
                        <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.pagadorNomeJuridico }}
                    </div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.pagadorNomeFantasia">
                        <span class="clean-modal-span">Nome fantasia:</span> {{ reciboIntencaoDeposito.pagadorNomeFantasia }}
                    </div>
                    <hr />
                    <div class="clean-modal-section-title">Recebedor</div>
                    <div class="clean-modal-text" *ngIf="reciboIntencaoDeposito.recebedor">
                        <span class="clean-modal-span">Razão social:</span> {{ reciboIntencaoDeposito.recebedor }}
                    </div>


                </div>

                <div class="col-12 clean-modal-footer">
                    <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
                </div>
            </ng-template>

            <!--Modal do Filtro-->
            <ng-template #filtro let-modal>
                <div class="col-12 modal-header clean-modal-header">
                    <div class="col-md-12">
                        <h5 class="modal-title clean-modal-title">
                            Aplicar filtro
                        </h5>
                        <p class="clean-modal-subtitle">
                            Filtre a listagem de pagamentos
                        </p>
                    </div>
                </div>
                <div class="col-12 clean-modal-content row">
                    <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                        <div class="clean-filter-input-container">
                            <label class="clean-filter-label" for="fCodigo">Código:</label>
                            <input id="fCodigo" #fCodigo class="clean-filter-input" type="text" value="{{ filtroCodigo }}" />
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                        <div class="clean-filter-input-container">
                            <label class="clean-filter-label" for="fIdentificador">Identificador:</label
                >
                <input
                    id="fIdentificador"
                    #fIdentificador
                    class="clean-filter-input"
                    type="text"
                    value="{{ filtroIdentificador }}"
                />
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="clean-filter-input-container">
                <label class="clean-filter-label" for="fValor">Valor:</label>
                            <input id="fValor" #fValor class="clean-filter-input" type="number" value="{{ filtroValor }}" />
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm--12 my-4">
                        <div class="clean-filter-input-container">
                            <label class="clean-filter-label" for="fDataCadastro">Data de Cadastro:</label
                >
                <input
                    id="fDataCadastro"
                    #fDataCadastro
                    class="clean-filter-input"
                    type="date"
                    value="{{ filtroDataCadastro }}"
                />
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="clean-filter-input-container">
                <label class="clean-filter-label" for="fDataProcessamento"
                    >Data de Processamento:</label
                >
                <input
                    id="fDataProcessamento"
                    #fDataProcessamento
                    class="clean-filter-input"
                    type="date"
                    value="{{ filtroDataProcessamento }}"
                />
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="clean-filter-input-container">
                <label class="clean-filter-label" for="fDataCancelamento"
                    >Data de Cancelamento:</label
                >
                <input
                    id="fDataCancelamento"
                    #fDataCancelamento
                    class="clean-filter-input"
                    type="date"
                    value="{{ filtroDataCancelamento }}"
                />
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button
            class="custom-filter-button"
            type="button"
            (click)="
                applyFilter(
                    fCodigo.value,
                    fIdentificador.value,
                    fValor.value,
                    fDataCadastro.value,
                    fDataProcessamento.value,
                    fDataCancelamento.value
                );
                modal.dismiss('Close click')
            "
        >
            APLICAR
        </button>
    </div>
</ng-template>

<ng-template #modalQRCodePagar let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12" style="text-align: center;">
                    <h5 class="modal-title clean-modal-title">
                        Pix QRCODE
                    </h5>
                    <img src="{{'data:image/png;base64,' + brCodePix.imagemBRCode}}" class="qrcode-img"/>
                    <!-- <p class="clean-modal-subtitle">
                        {{qrCodePix.brCode}}
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</ng-template>